import React, { useMemo, FC } from 'react';
import { Route, Routes,Navigate  } from 'react-router-dom';
import RouteContainer from './RouterContainer';
import { useAppResources } from '../config';

interface Resource {
  path: string;
  authRequired: boolean;
  component: React.FC;
}

const RouterComponent: FC = () => {

  const resources = useAppResources()

  const cachedRoutes = useMemo(() => {
    const routes = resources?.reduce((acc: JSX.Element[], resource: any) => {
      if (resource.path) {
        acc.push(
          <Route
            key={resource.path}
            path={resource.path}
            element={
              <RouteContainer
                authRequired={resource.authRequired}
                component={resource.component}
              />
            }
          />
        );
      }

      if (resource?.subMenu) {
        resource.subMenu.forEach((subResource: any) => {
          acc.push(
            <Route
              key={subResource.path}
              path={subResource.path}
              element={
                <RouteContainer
                  authRequired={subResource.authRequired}
                  component={subResource.component}
                />
              }
            />
          );
        });
      }

      return acc;
    }, []);

    // routes.push(
    //   <Route key="default" path="/anasayfa" element={<Navigate to="/login" />} />
    // );

   
    return routes;
  }, []);

  return <Routes>{cachedRoutes}</Routes>;

};

export default RouterComponent;